<template>
  <PrintJobList
    v-if="orderPrintJobs.length > 0"
    :print-jobs="orderPrintJobs"
    :loading="printJobsLoading"
    expandable
    media-component
    @zoom="$emit('zoom', $event)"
    @toggle-select-all="handleToggleSelectAll"
  >
    <template #title>
      <translate translate-context="edge-prints.order">Print Jobs for this Order</translate>
    </template>
    <template #photos="{ job }">
      <PrintJobMediaPreview
        ref="printJobPreview"
        :print-job="job"
        @zoom="$emit('zoom', $event)"
      />
    </template>
  </PrintJobList>
</template>

<script>
import { mapGetters } from 'vuex'
import PrintJobList from './PrintJobList.vue'
import PrintJobMediaPreview from './PrintJobMediaPreview.vue'

export default {
  name: 'OrderPrintJobs',
  components: {
    PrintJobList,
    PrintJobMediaPreview
  },
  computed: {
    ...mapGetters('edgePrints', [
      'orderPrintJobs',
      'loading'
    ]),

    printJobsLoading() {
      return this.loading.printJobs || false
    }
  },
  methods: {
    handleToggleSelectAll(printJobId) {
      // Find the PrintJobMediaPreview component for this job and call its toggleSelectAll
      const previews = this.$refs.printJobPreview
      if (Array.isArray(previews)) {
        const preview = previews.find(p => p.printJob.id === printJobId)
        if (preview) {
          preview.toggleSelectAll()
        }
      } else if (previews && previews.printJob.id === printJobId) {
        previews.toggleSelectAll()
      }
    }
  }
}
</script>
